import React from 'react';

import { useScreenDispatch } from '@gogame/screens';

import { SET_CHART_SETTINGS } from 'scenes/Trackers/Tracker/reducers';

import { useChartState, useChartIndex } from '../hooks';
import { SettingsForm } from './ChartSettings/SettingsForm';

export * from './ChartSettings/constants';

export const ChartSettingsAction = ({ disabled }) => {
  const chartIndex = useChartIndex();
  const chartState = useChartState();

  const dispatch = useScreenDispatch();

  const settingsSubmitHandler = (value) => {
    dispatch({
      type: SET_CHART_SETTINGS,
      payload: {
        index: chartIndex,
        value,
      },
    });
  };

  return (
    <SettingsForm
      onSubmit={settingsSubmitHandler}
      initialValues={chartState.settings}
      disabled={disabled}
    />
  );
};
